// src/components/BCP/ProgressBar.tsx
import React from 'react';
import { Step } from '../../types/bcpForm';

interface ProgressBarProps {
  steps: Step[];
  currentStep: number;
  totalSteps: number;
  onStepClick?: (stepNumber: number) => void;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ steps, currentStep, totalSteps, onStepClick }) => {
  return (
    <div className="mb-8">
      <div className="flex relative justify-between items-center">
        {/* Progress Line */}
        <div className="absolute top-5 left-0 w-full h-0.5 bg-gray-200">
          <div
            className="h-full bg-gradient-to-r from-blue-600 to-indigo-600 transition-all duration-500"
            style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
          ></div>
        </div>

        {steps.map((step) => (
          <div key={step.number} className="flex relative z-10 flex-col items-center">
            <button
              onClick={() => onStepClick?.(step.number)}
              className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-semibold text-sm transition-all duration-300 ${
                step.number <= currentStep
                  ? 'bg-gradient-to-r from-blue-600 to-indigo-600 border-blue-600 text-white hover:from-blue-700 hover:to-indigo-700 hover:shadow-md'
                  : 'bg-white border-gray-300 text-gray-500 hover:border-blue-400 hover:text-blue-600 hover:shadow-sm'
              } ${onStepClick ? 'cursor-pointer' : 'cursor-default'}`}
              disabled={!onStepClick}
              title={onStepClick ? `Go to ${step.title}` : undefined}
            >
              {step.number < currentStep ? (
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              ) : (
                step.number
              )}
            </button>
            <div className="mt-2 text-center">
              <p className={`text-sm font-medium ${step.number <= currentStep ? 'text-blue-600' : 'text-gray-500'}`}>
                {step.title}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;